const defaultsDeep = require("lodash/defaultsDeep");

$(window).ready(function () {
    $.ajaxSetup({
        headers: {
            "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
        },
    });

    cartInit();

    function cartInit() {
        $.ajax({
            url: "/carrinho",
            type: "post",

            success: function (response) {
                $("#count_cart").html(response.count);

                let emptyCart = `<div class="d-flex justify-content-center p-3 mt-5 msg-not-plan-selected">
                                Não existe plano adicionado no carrinho
                            </div>`;

                if (response.count === 0) {
                    $("#cart_body").html(emptyCart);
                } else {
                    $("#cart_body").remove();
                    $("#plan_lead").attr("class", "d-block");
                    response.data.forEach(function (data) {
                        getPlanData(data);
                    });
                }
            },
            error: function (error) {
                Swal.fire({
                    title: "Ops!",
                    icon: "error",
                    text: `${error.responseJSON.message}`,
                });
            },
            complete: () => {
                $(".loading").removeClass("active");
            },
        });
    }

    function getPlanData(data) {
        if (data.plan !== null && data.channels === undefined){
            data = data.plan;
            $("#plan_lead .remove_plan").attr("data-id", data.id);
            $("#plan_lead #plan_name").html(data.commercial_name);
            $("#plan_lead #plan_description").html(
                data.plan_description
                    ? `<span class="tag-contrate" id="plan_description"></span>`
                    : ""
            );
            // $("#plan_lead #plan_price").html(
            //     `R$ ${data.price.replace(".", ",")}${
            //         data.is_promotional ? "/mês*" : "/mês"
            //     }`
            // );

            $(".plan_download").removeClass("d-none");
            $("#plan_lead #plan_download").html(data.download + " Mb download");
            $("#plan_lead #plan_upload").html(data.upload + " Mb upload");
            $("#plan_lead #plan_installation_tax").html(
                data.instalattion_fee_no_debts === "0.00" || data.instalattion_fee_no_debts === null
                    ? "Grátis"
                    : `R$ ${data.instalattion_fee_no_debts.replace(".", ",")}`
            );
            $("#plan_lead #plan_id").val(data.id);

            let observationHTML = "";
            let svasPlanDetailHTML = "";

            data.observation.map(function (observation) {
                observationHTML += `<p style="font-size: x-small;">*${observation.observation}</p>`;
            });
            $("#observations").html(observationHTML);

            data.svas.map(function (sva) {
                svasPlanDetailHTML += `
                    <li class="about-apps">
                            <img class="img-fluid" src="${sva.logo}" alt="${sva.sva}">
                        </div>
                        <div class="balao">
                            <p style="margin-left: 5px">${sva.sva}</p>
                        </div>
                    </li>`;
            });
            $(".list-servicos-digitais").html(svasPlanDetailHTML);
        } else { //combo
            $("#plan_lead .remove_plan").attr("data-id", data.id);
            $("#plan_lead #plan_name").html(data.commercial_name);
            $(".channels").removeClass("d-none");
            $("#channels").html(data.channels.length);
            $("#plan_lead #plan_description").html(
                data.description
                    ? `<span class="tag-contrate" id="plan_description"></span>`
                    : ""
            );
            // $("#plan_lead #plan_price").html(
            //     `R$ ${data.price.replace(".", ",")}${
            //         data.is_promotional ? " /mês*" : " /mês"
            //     }`
            // );
            $("#plan_lead #plan_id").val(data.id);

            let observationHTML = "";

            data.observation.map(function (observation) {
                observationHTML += `<p style="font-size: x-small;">*${observation.observation}</p>`;
            });

            $("#observations").html(observationHTML);
        }

    }

    $(".addProduct").on("click", function (e) {
        let id = $(this).data("id");
        const plan_name = $(this).data("plan-name");
        const plan_price = $(this).data("plan-price");
        const isCombo = $(this).data("combo");

        $("#input_plan_name").val(plan_name);
        $("#input_plan_price").val(plan_price);
        $("#input_plan_id").val(id);

        const facebook_person = $("#fbp").val();
        const facebook_click = $("#fbc").val();
        $.ajax({
            url: "/carrinho/adicionar",
            type: "post",
            data: {
                id: id,
                isCombo: isCombo === undefined || isCombo === 'undefined' || isCombo === '' ? 0 : isCombo,
                facebook_person:
                    facebook_person != "undefined" ? facebook_person : null,
                facebook_click:
                    facebook_click != "undefined" ? facebook_click : null,
            },
            beforeSend: () => {
                $("#plan_lead").attr("class", "d-none");
                $(".loading").addClass("active");
            },
            success: function (response) {
                cartInit();
            },
            error: function (error) {
                Swal.fire({
                    title: "Ops!",
                    icon: "error",
                    text: `${error.responseJSON.message}`,
                });
            },
            complete: () => {
                $("#plan_lead").attr("class", "d-block");
                $(".loading").removeClass("active");
            },
        });
    });

    document.querySelectorAll('.no_plancenter').forEach(btnShowCart => {
        btnShowCart.addEventListener('click', ()=> {
            $("#input_plan_name").val(btnShowCart.getAttribute('data-plan-name'));
            $("#input_plan_price").val(btnShowCart.getAttribute('data-plan-price'));

            $("#plan_lead #plan_name").html(btnShowCart.getAttribute('data-plan-name'));
            $("#plan_lead #plan_price").html(`R$ ${btnShowCart.getAttribute('data-plan-price-br')} / mês`);

            $(".channels").removeClass("d-none");
            $("#channels").html(btnShowCart.getAttribute('data-inclusos'));

            $(".list-servicos-digitais").html(
                `<span class="txt_include" style="font-size: .875rem; font-weight: 700;">${btnShowCart.getAttribute('data-inclusos')}</span>`
            );

            $('#plan_lead .plan_download').remove();
        })
    })

    $(".remove_plan").on("click", function (e) {
        let id = $(this).data("id");

        Swal.fire({
            title: "Remover plano?",
            text: "Deseja realmente remover esse plano?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Sim",
            cancelButtonText: "Cancelar",
            reverseButtons: true,
        }).then((result) => {
            if (result.isConfirmed) {
                $.ajax({
                    type: "POST",
                    url: "/carrinho/remover",
                    data: {
                        plan_id: id,
                    },
                    success: function (data) {
                        if (!data.success) {
                            Swal.fire("Erro!", data.message, "error");
                        } else {
                            Swal.fire(
                                "Removido!",
                                data.message,
                                "success"
                            ).then(() => {
                                location.reload();
                            });
                        }
                    },
                });
            } else if (result.dismiss === Swal.DismissReason.cancel) {
                return false;
            }
        });
    });

    $(".saveLead").on("click", function () {
        const plan_id = $("#input_plan_id").val();
        const recaptcha = $("#recaptcha").val();
        const name = $("#cart-nome").val();
        const celphone = $("#cart-phone").val();
        const email = $("#cart-email").val();
        const document = $("#cart-cpf").val();
        const plan_name = $("#input_plan_name").val();
        const plan_price = $("#input_plan_price").val();
        const zip_code = $("#cart-cep").val();
        const address = $("#cart-adress").val();
        const address_number = $("#cart-number").val();
        const neighborhood = $("#cart-neighborhood").val();
        const city = $("#cart-city").val();
        const payment_method = $("#cart-form-pay").val();
        const due_date = $("#cart-day-pay").val();
        const facebook_person = $("#fbp").val();
        const facebook_click = $("#fbc").val();
        const mesh = $("#input-mesh-"+plan_id).val();
        const chip = $("#input-chip-"+plan_id).val();

        $.ajax({
            url: "/leads/adicionar",
            type: "post",
            data: {
                recaptcha,
                name,
                celphone,
                email,
                document,
                plan_name,
                plan_price,
                zip_code,
                address,
                address_number,
                neighborhood,
                city,
                payment_method,
                due_date,
                facebook_person:
                    facebook_person != "undefined" ? facebook_person : null,
                facebook_click:
                    facebook_click != "undefined" ? facebook_click : null,
                mesh,
                chip,
            },
            success: function (data) {},
            error: function (error) {
                if (
                    `${error.responseJSON.message}` ==
                    "The given data was invalid."
                ) {
                    var messageError = "Os dados fornecidos são inválidos.";
                }
                Swal.fire({
                    title: "Ops!",
                    icon: "error",
                    text: messageError,
                });

                $('[data-destino="stage-1"]').trigger("click");
            },
        });
    });

    $("#cart-cep").on("blur", function (e) {
        const cep = $(this).val().replace(/\D/g, "");

        function clearForm() {
            $("#cart-cep").val("");
            $("#cart-number").val("");
            $("#cart-adress").val("");
            $("#cart-neighborhood").val("");
            $("#cart-city").val("");
        }

        if (cep !== "") {
            $.ajax({
                url: "/viacep",
                type: "post",
                data: {
                    cep: cep,
                },
                beforeSend: () => {
                    $(".loading").addClass("active");
                },
                success: function (response) {
                    clearForm();

                    const data = response.data;

                    $("#cart-cep").val(data.cep);
                    $("#cart-adress").val(data.logradouro);
                    $("#cart-neighborhood").val(data.bairro);
                    $("#cart-city").val(data.localidade);

                    $("#cart-adress").trigger("blur");
                    $("#cart-neighborhood").trigger("blur");
                    $("#cart-city").trigger("blur");

                    if (data.logradouro) {
                        $("#cart-number").focus();
                    } else {
                        $("#cart-adress").focus();
                    }
                },
                error: function (error) {
                    Swal.fire({
                        title: "CEP não encontrado",
                        text: `${error.responseJSON.message}`,
                        icon: "warning",
                    });

                    clearForm();
                },
                complete: () => {
                    $(".loading").removeClass("active");
                },
            });
        } else {
            clearForm();
        }
    });

    $(".updateLead").on("click", function () {
        const recaptcha = $("#recaptcha").val();
        const name = $("#cart-nome").val();
        const celphone = $("#cart-phone").val();
        const email = $("#cart-email").val();
        const document = $("#cart-cpf").val();
        const plan_name = $("#input_plan_name").val();
        const plan_price = $("#input_plan_price").val();
        const zip_code = $("#cart-cep").val();
        const address = $("#cart-adress").val();
        const address_number = $("#cart-number").val();
        const neighborhood = $("#cart-neighborhood").val();
        const city = $("#cart-city").val();
        const payment_method = $("#cart-form-pay").val();
        const due_date = $("#cart-day-pay").val();
        const facebook_person = $("#fbp").val();
        const facebook_click = $("#fbc").val();

        $(".loading").addClass("active");
        $.ajax({
            url: "/leads/atualizar",
            type: "put",
            data: {
                recaptcha,
                name,
                celphone,
                email,
                document,
                plan_name,
                plan_price,
                zip_code,
                address,
                address_number,
                neighborhood,
                city,
                payment_method,
                due_date,
                _method: "put",
                facebook_person:
                    facebook_person != "undefined" ? facebook_person : null,
                facebook_click:
                    facebook_click != "undefined" ? facebook_click : null,
            },
            beforeSend: () => {
                $(".loading").addClass("active");
            },
            success: function (data) {
                $("#plan_lead").attr("class", "d-none");
                $(".loading").removeClass("active");
                var newUrl = window.location.href + "?obrigada-por-cadastrar";
                window.history.pushState({ path: newUrl }, "", newUrl);
                Swal.fire({
                    title: "Tudo Certo!",
                    icon: "success",
                    text: `${data.message}`,
                });
                setTimeout(() => {
                    window.history.replaceState(
                        { path: window.location.href },
                        "",
                        window.location.href.replace(
                            "?obrigada-por-cadastrar",
                            ""
                        )
                    );
                    window.location.reload();
                }, 3000);
            },
            error: function (error) {
                Swal.fire({
                    title: "Ops!",
                    icon: "error",
                    text: `${error.responseJSON.message}`,
                });

                $('[data-destino="stage-1"]').trigger("click");
            },
        });
    });
});
